import { Scalars, TaskInput, TaskType } from '@generated/base-types';
import { ManagerError } from '@new/common/utils/error-parser';
import { Task } from '../../../lib/types';

/* Query actions */

export class LoadTasks {
  public static readonly type = '[Tasks] Load';
}

export class LoadTasksSuccess {
  public static readonly type = '[Tasks] Load success';
  constructor(public readonly tasks: Task[]) {}
}

export class LoadTasksFailure {
  public static readonly type = '[Tasks] Load failure';
  constructor(public readonly error: ManagerError) {}
}

export class SetSelectedTaskIds {
  public static readonly type = '[Tasks] Set selected IDs';
  constructor(public readonly ids: string[]) {}
}

/* Mutation actions */

export class Failure {
  public static readonly type = '[Tasks] Mutation failure';
  constructor(public readonly error: ManagerError) {}
}

export class CreateTask {
  public static readonly type = '[Tasks] Create';
  constructor(
    public readonly attributes: TaskInput,
    public readonly taskType: TaskType
  ) {}
}

export class CreateTaskSuccess {
  public static readonly type = '[Tasks] Create success';
  constructor(public readonly taskType: TaskType) {}
}

export class DeleteTasks {
  public static readonly type = '[Tasks] Delete';
  constructor(public readonly taskIds: Scalars['ID'][]) {}
}

export class DeleteTasksSuccess {
  public static readonly type = '[Tasks] Delete success';
  constructor(public readonly taskIds: Scalars['ID'][]) {}
}
